import {
  DialogPositionStrategyInIframe,
  ENVIRONMENTS,
  RETAILERS,
} from '@shared/constants';
import { Environment } from '@shared/models';

export const environment: Environment = {
  lang: 'en-US',
  maxReward: 10000,
  production: true,
  maintenance: false,
  baseHref: '/en/',
  hasCampaignBis: false,
  maxSelectedChallenges: 10,
  retailerName: RETAILERS.PONA,
  env: ENVIRONMENTS.STAGING,
  projectType: 'loyaltyChallenge',
  backendUrl: 'https://b2c.clubcardchallenges.ai.eagleeye.com/api/v2',
  dialogPositionStrategyInIframe: DialogPositionStrategyInIframe.DEFAULT,
  enableSentry: true,
  ssrAllowedHosts: ['*.uat.ai.eagleeye.com'],
};
